// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2hNMV","list":"styles_list__S2y4Q"};